import './index.scss';

import Popup from 'components/Popup';
import ImagePopup from 'components/MiniProgramImage';
import {links, jump} from '../../tools';

class Bottom extends React.Component {
    showWechat() {
        Popup.show(ImagePopup, {url: 'https://s.qunarzz.com/vacation_tuan/2023/abudhabi/weImg.png', tip: '保存二维码  微信扫一扫关注'});
    }
    render() {
        return <div className="bottom">
            <div className="b-t">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/bottom-1.jpg" />
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/bottom-2.jpg" onClick={() => jump({touchUrl: links[0]})} data-sk-eid="gz_lyj"/>
            </div>
            <div className="b-b">
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/weibo.png" onClick={() => jump({touchUrl: links[1]})} data-sk-eid="gz_weibo"/>
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/tiktok.png" onClick={() => jump({touchUrl: links[2]})} data-sk-eid="gz_douyin"/>
                <img src="https://s.qunarzz.com/vacation_tuan/2023/abudhabi/wechat.png" onClick={() => this.showWechat()} data-sk-eid="gz_wx"/>
            </div>
        </div>;
    }
}


export default Bottom;